// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budgetList[data-v-76482a93] {\n  padding: 0.1rem 0.15rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n.budgetList > div[data-v-76482a93] {\n    padding: 0.05rem 0.1rem;\n    border: 1px solid #869AA6;\n    color: #869AA6;\n    cursor: pointer;\n    min-width: 1.8rem;\n    max-width: 2.1rem;\n}\n", ""]);
// Exports
module.exports = exports;
